// extracted by mini-css-extract-plugin
module.exports = {"tool_header_wrapper":"Dashboard_tool_header_wrapper__Gefmt","tool_header_icon":"Dashboard_tool_header_icon__3IQ17","tool_header_text":"Dashboard_tool_header_text__l4coa"};